module.exports = __webpack_public_path__ + "static/media/14_6.ee377725.jpg";